import { createRouter, createWebHistory } from "vue-router";
import i18n from "@/locale/index.js";

const routes = [
  // dashboard

  //side bar
  {
    path: "/MainView",
    name: "MainView",
    component: () => import("@/views/Dashboard/DashboardView.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/Dashboard/HomeView.vue"),
        meta: {
          name: i18n.global.t(`Sidebar.home`),
        },
      },
      {
        path: "/packages",
        name: "packages",
        component: () => import("@/views/Dashboard/PackageView.vue"),
        meta: {
          name: i18n.global.t("Sidebar.packages"),
        },
      },
      {
        path: "/myratings",
        name: "myratings",
        component: () => import("@/views/Dashboard/ratings/MyRatings.vue"),
        redirect: "/myratings/agentsratings",
        meta: {
          name: i18n.global.t("Sidebar.myRatings"),
        },
        children: [
          {
            path: "/myratings/agentsratings",
            name: "agentsratings",
            component: () =>
              import("@/views/Dashboard/ratings/ClientsRatings.vue"),
          },
          {
            path: "/myratings/employeesratings",
            name: "employeesratings",
            component: () =>
              import("@/views/Dashboard/ratings/EmployeesRatings.vue"),
          },
        ],
      },
      {
        path: "/visits",
        name: "visits",
        component: () => import("@/views/Dashboard/VisitsView.vue"),
        meta: {
          name: i18n.global.t("Sidebar.visits"),
        },
      },
      {
        path: "/SearchClient",
        name: "SearchClient",
        component: () => import("@/views/Dashboard/visits/SearchClient.vue"),
        meta: {
          name: i18n.global.t("Sidebar.myVisits"),
        },
      },
      {
        path: "/getClient",
        name: "getClient",
        component: () => import("@/views/Dashboard/visits/getClient.vue"),
        meta: {
          name: i18n.global.t("Sidebar.myVisits"),
        },
      },
      {
        path: "editPayType/:id",
        name: "editPayType",
        component: () => import("@/views/Dashboard/visits/EditPayType.vue"),
        meta: {
          name: i18n.global.t("Sidebar.myVisits"),
        },
      },
      {
        path: "/editClient/:id",
        name: "editClient",
        component: () => import("@/views/Dashboard/visits/EditClient.vue"),
        meta: {
          name: i18n.global.t("Sidebar.myVisits"),
        },
      },
      {
        path: "/payType/:id",
        name: "payType",
        component: () => import("@/views/Dashboard/visits/PayType.vue"),
        meta: {
          name: i18n.global.t("Sidebar.myVisits"),
        },
      },
      {
        path: "/empoyeesmanagement",
        name: "empoyeesmanagement",
        component: () =>
          import(
            "@/views/Dashboard/employeesManagement/EmpoyeesManagement.vue"
          ),
        meta: {
          name: i18n.global.t("Sidebar.employeesManagement"),
        },
      },
      {
        path: "/sevicemanagement",
        name: "sevicemanagement",
        component: () =>
          import("@/views/Dashboard/serviceManagement/ServiceManagement.vue"),
        meta: {
          name: i18n.global.t("Sidebar.serviceManagement"),
        },
      },
      {
        path: "/sevicemanagement/:id",
        name: "editservice",
        component: () =>
          import("@/views/Dashboard/serviceManagement/EditService.vue"),
        meta: {
          name: i18n.global.t("Sidebar.serviceManagement"),
        },
      },
      {
        path: "/reportmanagement",
        name: "reportmanagement",
        component: () => import("@/views/Dashboard/ReportManagement.vue"),
        meta: {
          name: i18n.global.t("Sidebar.reportManagement"),
        },
      },
      {
        path: "/rolesmanagement",
        name: "rolesmanagement",
        component: () => import("@/views/Dashboard/rolesmanagement.vue"),
        meta: {
          name: 'ادارة الصلاحيات',
        },
      },
      {
        path: "/addRole",
        name: "addRole",
        component: () => import("@/views/Dashboard/addRole.vue"),
        meta: {
          name: 'اضافة مستخدم',
        },
      },
      {
        path: "/editRole/:id",
        name: "editRole",
        component: () => import("@/views/Dashboard/editRole.vue"),
        meta: {
          name: 'تعديل مستخدم',
        },
      },
      {
        path: "/employeesmanagement/:id",
        name: "editemployee",
        component: () =>
          import("@/views/Dashboard/employeesManagement/EditEmployee.vue"),
        meta: {
          name: i18n.global.t("Sidebar.employeesManagement"),
        },
      },
      {
        path: "/jopmanagement",
        name: "jopmanagement",
        component: () =>
          import("@/views/Dashboard/jobManagement/JobManagement.vue"),
        meta: {
          name: i18n.global.t("Sidebar.jopManagement"),
        },
      },
      {
        path: "/jobmanagement/:id",
        name: "editjob",
        component: () => import("@/views/Dashboard/jobManagement/EditJob.vue"),
        meta: {
          name: i18n.global.t("Sidebar.jopManagement"),
        },
      },
      {
        path: "/wallet",
        name: "wallet",
        component: () => import("@/views/Dashboard/WalletView.vue"),
        meta: {
          name: i18n.global.t("Sidebar.wallet"),
        },
      },
      // setting routes
      {
        path: "/setting/settings",
        name: "setting",
        component: () => import("@/views/Dashboard/setting/SettingView.vue"),
        meta: {
          name: i18n.global.t("Sidebar.accountSettings"),
        },
      },
      {
        path: "/setting/editprofile",
        name: "editprofile",
        component: () => import("@/views/Dashboard/setting/EditProfile.vue"),
        meta: {
          name: i18n.global.t("Settings.editProfile"),
        },
      },
      {
        path: "/setting/changePhoneNumber",
        name: "changephonenumber",
        component: () =>
          import("@/views/Dashboard/setting/changePhoneNumber/ChangePhone.vue"),
        meta: {
          name: i18n.global.t("Settings.changePhoneNumber"),
        },
      },
      {
        path: "/setting/newphonenumber",
        name: "newphonenumber",
        component: () =>
          import(
            "@/views/Dashboard/setting/changePhoneNumber/NewPhoneNumber.vue"
          ),
        meta: {
          name: i18n.global.t("Settings.changePhoneNumber"),
        },
      },
      {
        path: "/setting/confirmphonenumber",
        name: "confirmphonenumber",
        component: () =>
          import(
            "@/views/Dashboard/setting/changePhoneNumber/ConfirmPhoneNumber.vue"
          ),
        meta: {
          name: i18n.global.t("Settings.changePhoneNumber"),
        },
      },
      {
        path: "/setting/createQRcode",
        name: "createqrcode",
        component: () => import("@/views/Dashboard/setting/CreateQRcode.vue"),
        meta: {
          name: i18n.global.t("Settings.create") + " " + "QR code",
        },
      },
      {
        path: "/setting/determinvisits",
        name: "determinvisits",
        component: () =>
          import("@/views/Dashboard/setting/DetermineVisits.vue"),
        meta: {
          name: i18n.global.t("Settings.determinVisits"),
        },
      },
      {
        path: "/setting/mycode",
        name: "mycode",
        component: () => import("@/views/Dashboard/setting/MyCode.vue"),
        meta: {
          name: i18n.global.t("Settings.myCode"),
        },
      },
      {
        path: "/setting/addworkinghours",
        name: "addworkinghours",
        component: () =>
          import("@/views/Dashboard/setting/AddWorkingHours.vue"),
        meta: {
          name: i18n.global.t("Settings.addWorkingHours"),
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/Dashboard/ProfileView.vue"),
        meta: {
          name: i18n.global.t("Sidebar.profile"),
          image: require("@/assets/imgs/icons/user.png"),
          showInSidebar: true,
        },
      },
      {
        path: "/notifications",
        name: "notifications",
        component: () => import("@/views/Dashboard/NotificationVue.vue"),
        meta: {
          name: i18n.global.t("Sidebar.notification"),
        },
      },
      {
        path: "/legal/legal",
        name: "legal",
        component: () => import("@/views/Dashboard/legal/LegalView.vue"),
        meta: {
          name: i18n.global.t("Legal.legal"),
        },
      },
      {
        path: "/legal/termsAndConditions",
        name: "terms",
        component: () =>
          import("@/views/Dashboard/legal/TermsAndConditions.vue"),
        meta: {
          name: i18n.global.t("Legal.terms"),
        },
      },
      {
        path: "/legal/aboutApp",
        name: "aboutapp",
        component: () => import("@/views/Dashboard/legal/AboutApp.vue"),
        meta: {
          name: i18n.global.t("Legal.aboutApp"),
        },
      },
      {
        path: "/legal/Q&A",
        name: "Q&A",
        component: () => import("@/views/Dashboard/legal/Q&A.vue"),
        meta: {
          name: i18n.global.t("Legal.questions"),
        },
      },
      {
        path: "/legal/privacy",
        name: "privacy",
        component: () => import("@/views/Dashboard/legal/PrivacyPolicy.vue"),
        meta: {
          name: i18n.global.t("Legal.privacy"),
        },
      },
      {
        path: "/legal/contact",
        name: "contact",
        component: () => import("@/views/Dashboard/legal/ContactWithUs.vue"),
        meta: {
          name: i18n.global.t("Legal.contact"),
        },
      },
    ],
  },
  // auth
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/Auth/AuthView.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/Auth/LoginView.vue"),
        meta: {
          name: i18n.global.t("Auth.login"),
        },
      },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import("@/views/Auth/ForgetPasswordView.vue"),
        meta: {
          name: i18n.global.t("Auth.forgot_password"),
        },
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: () => import("@/views/Auth/ResetPasswordView.vue"),
        meta: {
          name: i18n.global.t("Auth.reset_password"),
        },
      },
      {
        path: "/otp",
        name: "otp",
        component: () => import("@/views/Auth/OtpView.vue"),
        meta: {
          name: i18n.global.t("Auth.otp"),
        },
      },
      {
        path: "/createAccount",
        name: "createAccount",
        component: () => import("@/views/Auth/CreateAccount.vue"),
        meta: {
          name: i18n.global.t("Auth.createAccount"),
        },
      },
      {
        path: "/termsAndConditions",
        name: "termsAndConditions",
        component: () => import("@/views/Auth/TermsAndConditions.vue"),
        meta: {
          name: i18n.global.t("Auth.termsAndConditions"),
        },
      },
    ],
    // pageNotFound
  },
  {
    path: "/:pathMatch(.*)*",
    name: "pageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
    meta: {
      name: i18n.global.t("pageNotFound"),
    },
  },

  // client rating routes
  {
    path: "/clientAuth",
    name: "clientAuth",
    component: () => import("@/views/ClientRating/Auth/AuthClient.vue"),
    children: [
      {
        path: "/clientRating/clientLogin",
        name: "loginClient",
        component: () => import("@/views/ClientRating/Auth/LoginClient.vue"),
        meta: {
          name: i18n.global.t("Auth.login"),
        },
      },
      {
        path: "/clientRating/confirmCode",
        name: "confirmCode",
        component: () => import("@/views/ClientRating/Auth/ConfirmCode.vue"),
        meta: {
          name: i18n.global.t("Auth.otp"),
        },
      },
      {
        path: "/clientRating/registerClient",
        name: "registerClient",
        component: () => import("@/views/ClientRating/Auth/RegisterClient.vue"),
        meta: {
          name: i18n.global.t("Auth.newAccount"),
        },
      },
      {
        path: "/clientRating/termsAndConditions",
        name: "termsAndConditions",
        component: () => import("@/views/ClientRating/Auth/TermsAndConditions.vue"),
        meta: {
          name: i18n.global.t("Auth.termsAndConditions"),
        }
      }
    ],
  },
  {
    path: "/clientRating/rateSalon/rate",
    name: "rate",
    component: () => import("@/views/ClientRating/RateSalon/RateView.vue"),
    meta: {
      name: i18n.global.t("clientRating"),
      requiresClientAuth: true,
    },
  },
  {
    // Client-specific Page Not Found (404)
    path: "/clientRating/:pathMatch(.*)*", // Matches all undefined client rating routes
    name: "clientPageNotFound",
    component: () => import("@/views/ClientRating/PageNotFound.vue"),
    meta: {
      name: i18n.global.t("pageNotFound"),
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Set document title
  document.title = to.meta.name;

  // Check for authentication requirements
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("token")) {
      return next({ name: "login" });
    }
  }

  if (to.matched.some((record) => record.meta.requiresClientAuth)) {
    if (!localStorage.getItem("clientToken")) {

      const urlParams = new URLSearchParams(window.location.search);
      const providerId = urlParams.get("ProviderId");

      if (providerId) {
        localStorage.setItem("providerId", providerId);
      }
      return next({ name: "loginClient" });
    }
  }
  next();
});

export default router;
